import loadable from '@loadable/component'

export default [
  {
    // 游戏广场入口（如后续需要从 /game 打开）
    path: '/game/Sinbad',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-Sinbad" */ '~/pages/game/Sinbad'
        )
    ),
  },
  {
    // 房间内玩法入口：Sinbad’s Legend 主游戏页
    path: '/gameRoom/Sinbad',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-Sinbad" */ '~/pages/game/Sinbad'
        )
    ),
  },
]
